module.exports = __webpack_public_path__ + "static/media/faq.b8459c23.svg";